module.exports = ".editor-loading {\n  text-align: center;\n  -webkit-animation: fade-in 1.5s ease-in-out;\n          animation: fade-in 1.5s ease-in-out; }\n  .editor-loading .editor-loading-message {\n    margin-top: 0.5em;\n    font-size: 1.25em; }\n  @-webkit-keyframes fade-in {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n  @keyframes fade-in {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/editor/editor-loading/editor-loading.component.sass
// module id = ./src/app/editor/editor-loading/editor-loading.component.sass
// module chunks = main